import { Component, ViewChild } from '@angular/core'
import { MatMenu } from '@angular/material/menu'
import { CptGoogleTagmanagerService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import {
  type CustomerPortalConfig, type Link
} from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { SharedService } from '../../../../services/shared.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-mobile-menu',
  standalone: true,
  templateUrl: './mobile-menu.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class MobileMenuComponent {
  constructor (
    private readonly cptGtmService: CptGoogleTagmanagerService,
    public sharedService: SharedService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.mobileMenuLinks =
    this.remoteConfigService.getArrayValues<Link[]>('mobileMenu.links')
  }

  @ViewChild(MatMenu, { static: true }) menu: MatMenu

  mobileMenuLinks

  sendGTMNavigationData (label: string, linkType?: string): void {
    this.cptGtmService.sendNavigationLinkData(
      null,
      'Main Navigation',
      label,
      linkType
    )
  }
}
